
export default {
  props: ["scholarship"],
  data() {
    return {
      overflow: {
        scholarship: {
          isOverflow: false,
          isExpanded: false,
        },
        
      },
    };
  },
  methods: {
    handleExpanding(name) {
      this.overflow[name].isExpanded = !this.overflow[name].isExpanded;
    },
  },
  watch: {
    "overflow.scholarship.isExpanded"(value) {
      value
        ? (this.$refs.scholarshipRef.style.height = "100%")
        : (this.$refs.scholarshipRef.style.height = "360px");
    },
  
   
  },
  mounted(){
    const scholarshipRef = this.$refs.scholarshipRef;
  
 
    const limitedHeight = 360;
    if (scholarshipRef.clientHeight > limitedHeight) {
      this.overflow.scholarship.isOverflow = true;
      scholarshipRef.style.height = `${limitedHeight}px`;
    }
   
  
  }
};
